import { TopBar, CoachRibbon } from "./kit";
import { AccessibilityMenu } from "./AccessibilityMenu";
import { NotificationsBell } from "./NotificationsBell";
import { AccountMenu } from "./AccountMenu";

/**
 * Issue #780 (D140), extended by #1121 (D221 O1) — the shared header's
 * "drawn" branch, lifted out of `Layout.jsx` so its decisions can be
 * rendered in a unit test (`Layout.jsx` imports `react-router-dom`, whose
 * ESM build this Jest config cannot resolve). `Layout` still owns WHEN the
 * branch applies (`drawnTopBar`, set by `CoachPortal.jsx` from
 * `lib/coachChromeGate.js`); this component owns what the branch draws.
 *
 * - A COACH gets the white bar (D216) with the coach ribbon under it, Your
 *   players current on `/coach-portal`. The bar keeps `layout-topbar-white`,
 *   the testid of the white shared-header branch, so the navy-only CSS rule
 *   that whitens a navy bar's glyphs (`index.css`, `layout-topbar-navy`)
 *   does not reach it.
 * - Any other role that reaches the branch (an admin never does today:
 *   `computeDrawnCoachChrome` is coach-only) keeps the navy bar and no
 *   ribbon. Admin's menus are round 9.
 */
export default function DrawnTopBar({ isCoach, isPlayer, pathname, homeHref, homeLabel, hideTextSize, onPlayersClick }) {
  if (isCoach) {
    return (
      <>
        <TopBar
          variant="white"
          homeHref={homeHref}
          homeLabel={homeLabel}
          endControls={
            <>
              <NotificationsBell compact surface="white" />
              <AccessibilityMenu hideTextSize={hideTextSize} surface="white" />
              <AccountMenu empty surface="white" hasRibbon />
            </>
          }
          data-testid="layout-topbar-white"
        />
        <CoachRibbon current={pathname.startsWith("/coach-portal") ? "players" : undefined} onCurrentClick={onPlayersClick} />
      </>
    );
  }
  return (
    <TopBar
      variant="navy"
      homeHref={homeHref}
      homeLabel={homeLabel}
      endControls={
        <>
          {isPlayer && <NotificationsBell compact />}
          <AccessibilityMenu hideTextSize={hideTextSize} />
          <AccountMenu empty />
        </>
      }
      data-testid="layout-topbar-navy"
    />
  );
}
